module.exports = __webpack_public_path__ + "static/media/credit_platinum_old.d57bb1f3.svg";